<h3 class="mt-0 mb-12">{{ userAttribute.translationKey | translate }}</h3>
<mat-form-field class="w-100-p" *ngIf="isDatePickerVisible; else noDatePicker">
    <mat-label>{{ 'GENERAL.PROPERTY.CHOOSE_DATE' | translate }}</mat-label>
    <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRange" [min]="minDate" [max]="maxDate">
        <input
            matStartDate
            formControlName="startDate"
            autocomplete="off"
            readonly
            inputmode="none"
            (click)="picker.open()"
        />
        <input
            matEndDate
            formControlName="endDate"
            autocomplete="off"
            readonly
            inputmode="none"
            (click)="picker.open()"
        />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker
        #picker
        [restoreFocus]="false"
        (opened)="onRangePickerOpened()"
        (closed)="onRangePickerClosed()"
    ></mat-date-range-picker>
</mat-form-field>

<ng-template #noDatePicker>
    <div class="no-options-container" fxLayout="column">
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-icon svgIcon="empty"></mat-icon>
            <p class="mt-12 mb-24">{{ 'GENERAL.MESSAGE.NO_DEFINED_VALUES' | translate }}</p>
        </div>
    </div>
</ng-template>
